export default __webpack_public_path__ + "static/media/aahpmPoster.6e5d2121.pdf";